// The browser-storage keys the application forms write, in one place.
//
// Why this file exists: pages/Privacy.tsx §6 lists these keys by name, and until
// 2026-09-17 it named `cc_application_draft_v1` — a key that went away with
// ApplicationForm.tsx at the 2026-09-02 relaunch. The policy's own header
// promises "if any of those change, this page changes with them", and the test
// meant to enforce that had hard-coded the wrong name too, so both drifted
// together for two weeks and the published policy described storage the site
// did not use.
//
// The forms and the policy now read the same constants, so a renamed key breaks
// the build or the test rather than quietly making a legal document false.
// Attribution's own keys stay in lib/attribution.ts, exported for the same
// reason (`STORE_KEY`, `LANDING_KEY`).

/** The six-step form at /application. */
export const V2_REPLICA_DRAFT_KEY = 'cc_v2replica_draft_v1';

/** The type-first experiment at /application-preview (CMSY-78). */
export const TYPE_FIRST_DRAFT_KEY = 'cc_v3typefirst_draft_v1';

/** How long a saved draft is restorable for. Disclosed as "7 days". */
export const DRAFT_TTL_MS = 7 * 24 * 3600 * 1000;
